"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationListPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const component_1 = require("@front/components/site-menu/component");
const translations_1 = require("@front/application/globals/translations");
const trans_1 = require("../../../../../common/translations/trans");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="conversation-list-page">
    <crud-table 
      title="${'conversations.listTitle'.t()}" 
      addText="${'conversations.newConversation'.t()}"
      resource="conversation"
      searchPlaceholder="${'conversations.search_placeholder'.t()}" 
      listEndpoint="conversation.list"
      deleteEndpoint="conversation.delete"
      queryParam="q" 
      editRoute="/conversation/preview/:id"
      addRoute="/ai/chat"
      autoLoad="false"
      :actions="${x => x.baseActions}" 
      :columns="${x => x.tableColumns}"
      :data="${x => x.conversations}"
      :loading="${x => x.loading}"
      :searchQuery="${x => x.searchQuery}"
      :currentPage="${x => x.currentPage}"
      :totalPages="${x => x.totalPages}"
      :perPage="${x => x.perPage}"
      :totalCount="${x => x.totalCount}"
      @search-submit="${(x, c) => x.onSearchSubmit(c.event)}"
      @page-change="${(x, c) => x.onPageChange(c.event.detail)}"
      @add-click="${x => x.createConversation()}">
    </crud-table>
  </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.conversation-list-page .crud-table .table th {
  border-top: none;
  font-weight: 600;
  color: #495057;
  background-color: #f8f9fa;
}
.conversation-list-page .crud-table .table td {
  vertical-align: middle;
}
.conversation-list-page .crud-table .pagination {
  justify-content: center;
  margin-top: 1rem;
}
.conversation-list-page .crud-table .search-container {
  margin-bottom: 1rem;
}
.conversation-list-page .crud-table .search-container .input-group {
  max-width: 300px;
}
.conversation-list-page .action-buttons {
  display: flex;
  gap: 0.25rem;
}
.conversation-list-page .action-buttons .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.conversation-list-page .loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}
.conversation-list-page .no-data-message {
  text-align: center;
  padding: 3rem 1rem;
  color: #6c757d;
}
.conversation-list-page .no-data-message .icon {
  font-size: 3rem;
  color: #dee2e6;
  margin-bottom: 1rem;
}`;
const shadowOptions = { "mode": "open" };
let ConversationListPage = class ConversationListPage extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.conversations = [];
        this.loading = false;
        this.searchQuery = '';
        this.currentPage = 1;
        this.totalPages = 1;
        this.perPage = 20;
        this.totalCount = 0;
        this.baseActions = [
            {
                key: 'preview',
                icon: 'simple-icon-magnifier',
                label: '',
                variant: 'info',
                tooltip: 'conversations.tooltips.preview'.t(),
                tooltipDirection: 'left',
                handler: async (id) => {
                    this.previewConversation.bind(this)(id);
                }
            },
            {
                key: 'delete',
                icon: 'simple-icon-trash',
                label: '',
                variant: 'danger',
                tooltip: 'conversations.tooltips.delete'.t(),
                tooltipDirection: 'left',
                handler: async (id) => {
                    this.deleteConversation.bind(this)(id);
                }
            }
        ];
        this.tableColumns = [
            {
                key: 'title',
                header: 'conversations.title'.t(),
                formatter: (title, row) => {
                    return `${row.favorite ? `<app-star style="margin-right: 5px;" :full="true" width="15px"
                                                    height="15px"></app-star>` : ''}${title}`;
                }
            },
            {
                key: 'avatar',
                header: 'conversations.avatar'.t(),
                formatter: (avatar) => (avatar === null || avatar === void 0 ? void 0 : avatar.name) || '-'
            },
            {
                key: 'lastActivity',
                header: 'conversations.last_activity'.t(),
                formatter: (date) => {
                    if (!date)
                        return '-';
                    return new Date(date).toLocaleString();
                }
            },
            {
                key: 'model',
                header: 'conversations.model'.t(),
                formatter: (model) => { var _a; return ((_a = model === null || model === void 0 ? void 0 : model.model) === null || _a === void 0 ? void 0 : _a.label) || '-'; }
            }
        ];
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadData();
    }
    async loadData() {
        this.loading = true;
        const queryParams = {
            p: this.currentPage,
            per_page: this.perPage.toString()
        };
        if (this.searchQuery.trim()) {
            queryParams.q = this.searchQuery.trim();
        }
        try {
            const response = await this.apiService.back.get('conversation.list', {
                queryParams
            });
            if (response && response.success && Array.isArray(response.data)) {
                this.conversations = response.data;
                this.totalCount = response.count;
                this.totalPages = Math.max(1, Math.ceil(response.count / this.perPage));
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'conversations.failedToLoad'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('conversations.failedToLoad'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    onSearchSubmit(event) {
        this.searchQuery = event.detail.query;
        this.currentPage = 1;
        this.loadData();
    }
    clearSearch() {
        this.searchQuery = '';
        this.currentPage = 1;
        this.loadData();
    }
    onPageChange(page) {
        // Page number from pagination component is 1-based, same as our internal currentPage
        this.currentPage = page;
        this.loadData();
    }
    async previewConversation(id) {
        component_1.SiteMenu.goto.bind(this)(`/conversation/preview/${id}`);
    }
    async deleteConversation(id) {
        const conversation = this.conversations.find(c => c.id === id);
        if (!conversation)
            return;
        const confirmMessage = (0, trans_1.translate)('conversations.delete.confirm', (0, translations_1.getLanguage)() || 'en')
            .replace('{title}', conversation.title);
        const confirmed = await this.popupService.confirm(confirmMessage);
        if (!confirmed)
            return;
        try {
            const response = await this.apiService.back.delete('conversation.delete', {
                routeParams: { id }
            });
            if (response.success) {
                this.notifyService.notify('conversations.delete.success'.t());
                await this.loadData();
            }
            else {
                this.notifyService.notify(response.error || 'conversations.delete.error'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Error deleting conversation:', error);
            this.notifyService.notify('conversations.delete.error'.t(), 'error');
        }
    }
    createConversation() {
        component_1.SiteMenu.goto.bind(this)('/ai/chat');
    }
};
exports.ConversationListPage = ConversationListPage;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ConversationListPage.prototype, "conversations", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ConversationListPage.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ConversationListPage.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ConversationListPage.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ConversationListPage.prototype, "totalPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ConversationListPage.prototype, "perPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ConversationListPage.prototype, "totalCount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ConversationListPage.prototype, "baseActions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ConversationListPage.prototype, "tableColumns", void 0);
exports.ConversationListPage = ConversationListPage = __decorate([
    (0, client_1.RWSView)('conversation-list-page', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], ConversationListPage);
ConversationListPage.defineComponent();
